// extracted by mini-css-extract-plugin
export default {"ShufersalShirt":"ShufersalShirt_ShufersalShirt__6-BTH","Image":"ShufersalShirt_Image__qxULL"};